<template>
    <client-page>
        <page-section class="page-section--first page-section--last">
            <template slot="tit">공지사항</template>
            <notification-list v-if="!$route.params._notification"></notification-list>
            <notification-view v-else></notification-view>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/components/client/templates/client-page.vue";
import PageSection from "@/components/client/templates/page-section.vue";
import NotificationList from "@/components/client/center/notifications/notification-list.vue";
import NotificationView from "@/components/client/center/notifications/notification-view.vue";

export default {
    components: {
        ClientPage,
        PageSection,
        NotificationList,
        NotificationView,
    },
};
</script>
